import React, {Fragment, useState} from 'react';
import { useDispatch, useSelector } from "react-redux";
import * as routes from 'constants/routes';
import './index.scss';

import {addPopup, addToken, deleteUserAddress , setDefaultAddress} from "../../../redux/actions";

import * as popups from '../../../constants/popup-types';

//components
import AddForm from './addForm';

//assets
import address from 'assets/icons/address.svg';
import arrow from 'assets/icons/arrow-black.svg';
import {getMediaPath} from "../../../app/functions";

const Address = (props) =>{

    //import redux state
    const text = useSelector(state => state.config.Translations);
    const deviceState = useSelector(state => state.state.deviceState);
    const user = useSelector(state => state.config.UserData);
    const isDesktop = deviceState === 'desktop' || deviceState === 'desktop-large';
    const [step, updateStep] = useState(1);
    const [selectedAddress, setSelectedAddress] = useState(false);
    const dispatch = useDispatch();

    const performeDeleteAddress = (addressId) =>{
        dispatch(deleteUserAddress({addressId: addressId}));
    };
    const handleRemoveClick = (item) =>{

        dispatch(addPopup({
            type: popups.DELETE_CARD,
            credit_number: item['street_name'] + ' ' + item['house_num'] + ', ' + item['city_name'],
            tokenId: item.id,
            zipCode: item['zip_code'],
            holderName: 'קומה ' + item['floor_num'] + ' דירה ' + item['apartment'],
            deleteText: text['delete_address_btn'],
            title: text['delete_address_title'],
            action:()=> performeDeleteAddress(item['id']),
        }));
    };
    const handleAddCardClick = () =>{
        setSelectedAddress(false);
        updateStep(2);
        dispatch(addToken());
    };
    const handleUpdateAddress = (address) =>{
        setSelectedAddress(address);
        updateStep(2);
    };
    const setAddressAsDefault = (id) =>{
        dispatch(setDefaultAddress({addressId: id}));
    };
    const handleBackClick = () => {
        if(step === 1) {
            props.history.push(routes.personal_zone);
        } else {
            updateStep(1);
        }
    }
    let getCards = () =>{

        let res = [];

        for(let key in user.addressArr){
            const item = user.addressArr[key];
            const isDefault = item.default;
            if (item.active) {
                res.push(
                    <div key={key} className='address-wrapper'>
                        <div className='address-name'>
                            <span>{item['street_name'] + ' ' + item['house_num'] + (isDesktop ? ',' : '')}</span>
                            <span>{item['city_name']}</span>
                        </div>
                        <span className='zip-code'>{item['zip_code']}</span>
                        <span className='home'>{'קומה ' + item['floor_num'] + ' דירה ' + item['apartment']}</span>
                        <div className='default-address'>
                            {isDefault && <span className='default-span'>{text['address_default']}</span>}
                            {!isDefault && <span className='change-default'
                                                 onClick={() => setAddressAsDefault(item.id)}>{text['address_default_change']}</span>}
                        </div>

                        <div className='actions'>
                            <span onClick={() => handleUpdateAddress(item)}>{text['address_update']}</span>
                            <div className='divider'/>
                            <span onClick={() => handleRemoveClick(item)}>{text['address_remove']}</span>
                        </div>
                    </div>
                )
            }
        }
        return res;
    };
    

    return(
        <div className="mobile-layout open">
            <div className='top'>
                <img src={isDesktop ? getMediaPath(address) : getMediaPath(arrow)} alt='' className="icon" onClick={ handleBackClick } />
                <span className="title">{ text.personal_zone_address }</span>
            </div>
            <section className={'address' + (step === 2 ? 'form-mode' : '')}>
                {step === 1 &&
                <Fragment>
                    {getCards()}
                    {getCards().length < 1 && isDesktop && <div className='no-content-placeholder'>{text['no_address_placeholder']}</div>}
                    <button className='add-card-btn' onClick={handleAddCardClick}>{text['address_add']}</button>
                </Fragment>
                }
                {step === 2 &&
                <Fragment>
                    <AddForm onSubmit={()=> updateStep(1)} data={selectedAddress}/>
                </Fragment>
                }
            </section>
        </div>
    )
};

export default Address;
